import { CSSProperties, HTMLAttributes, memo, ReactNode } from 'react';
import styled from 'styled-components';

import { SKEW_ANGLE } from '@utils/constants';

import TouchableOpacity from './TouchableOpacity';

const Container = styled(TouchableOpacity)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 4px;
  transform: skew(-${SKEW_ANGLE}deg);
  background-color: ${({ theme }) =>
    `${theme.colors.black}${theme.opacity[60]}`};
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
  transform: skew(${SKEW_ANGLE}deg);
`;

type Props = {
  icon: string | ReactNode;
  iconStyle?: CSSProperties;
  style?: CSSProperties;
  onClick?: () => void;
} & HTMLAttributes<HTMLButtonElement>;

const SkewedIconButton = ({
  icon,
  iconStyle,
  style,
  onClick,
  ...props
}: Props) => {
  return (
    <Container style={style} onClick={onClick} {...props}>
      {typeof icon === 'string' ? (
        <Icon src={icon} alt='icon' style={iconStyle} />
      ) : (
        icon
      )}
    </Container>
  );
};

export default memo(SkewedIconButton);
